export const IconKey = Object.freeze({
	addToChat: 'add-to-chat',
	collabEntities: 'collab-entities',
});
